__turbopack_context__.v({
  "CertCopy": "CertificationList-module-sass-module__GxFv9G__CertCopy",
  "Certification": "CertificationList-module-sass-module__GxFv9G__Certification",
  "CertificationList": "CertificationList-module-sass-module__GxFv9G__CertificationList",
  "Certifications": "CertificationList-module-sass-module__GxFv9G__Certifications",
  "Cont": "CertificationList-module-sass-module__GxFv9G__Cont",
  "Copy": "CertificationList-module-sass-module__GxFv9G__Copy",
  "Image": "CertificationList-module-sass-module__GxFv9G__Image",
  "Light": "CertificationList-module-sass-module__GxFv9G__Light",
  "Main": "CertificationList-module-sass-module__GxFv9G__Main",
  "NoLightTitlePadding": "CertificationList-module-sass-module__GxFv9G__NoLightTitlePadding",
  "Title": "CertificationList-module-sass-module__GxFv9G__Title",
});
